<crowdctrl-unauthenticated-page
  [pageTitle]="pageTitle"
  [showFooter]="false"
  defaultHref="/about/how-it-works"
>
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle><strong>CrowdCTRL Boards</strong></h1>
      <p crowdctrlUnauthIntroLead>
        Room-scale displays so everyone can see queue state without crowding the desk.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section">
      <p class="about-project__text">
        <strong>CrowdCTRL Boards</strong> answers the question “what does the room look like from
        the back row?” It is another standalone surface, meant for a wall monitor or TV, showing
        live queue and status so people waiting can orient themselves without crowding the desk.
        Like <strong>CrowdCTRL Forms</strong>, it does not hand visitors keys to the rest of the
        platform.
      </p>
    </section>

    <a
      href="/about/how-it-works"
      class="about-project__back-link"
      (click)="unauthNav.forward($event, '/about/how-it-works')"
      >Back to How it all works</a
    >
  </div>
</crowdctrl-unauthenticated-page>
